const loadingLabel = "In caricamento";
const itCH = {
  loadingLabel
};
export {
  itCH as default,
  loadingLabel
};
